import React from 'react';
import { X, Download } from 'lucide-react';
import { getTenantName } from '../../utils/brandingStyles';

interface IframePDFViewerProps {
  pdfUrl: string;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

const IframePDFViewer: React.FC<IframePDFViewerProps> = ({ 
  pdfUrl, 
  isOpen, 
  onClose, 
  title = "Guide d'utilisation" 
}) => {
  // Debug logs
  React.useEffect(() => {
    console.log('IframePDFViewer - RENDER - isOpen:', isOpen, 'pdfUrl:', pdfUrl);
    console.log('IframePDFViewer - Props reçues:', { isOpen, pdfUrl, title });
  }, [isOpen, pdfUrl, title]);

  const downloadPDF = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'guide-utilisation.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  console.log('IframePDFViewer - RENDER CHECK - isOpen:', isOpen, 'pdfUrl:', pdfUrl);

  // Ne pas afficher si pas ouvert OU si pas d'URL
  if (!isOpen || !pdfUrl) {
    console.log('IframePDFViewer - PAS AFFICHÉ car isOpen:', isOpen, 'pdfUrl:', pdfUrl);
    return null;
  }

  console.log('IframePDFViewer - AFFICHAGE DU MODAL');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-lg shadow-2xl w-full h-full max-w-6xl max-h-[95vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-600 rounded-t-lg" style={{ backgroundColor: '#1f2937' }}>
          <h2 className="text-xl font-semibold text-white">{title}</h2>
          <div className="flex items-center space-x-4">
            {/* Download button */}
            {/* <button
              onClick={downloadPDF}
              className="px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors duration-200 flex items-center gap-2 border border-gray-600"
              title="Télécharger"
            >
              <Download size={16} />
              <span className="font-medium">Télécharger</span>
            </button> */}

            {/* Close button */}
            <button
              onClick={onClose}
              className="p-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 border border-red-500"
              title="Fermer"
            >
              <X size={18} />
            </button>
          </div>
        </div>

        {/* PDF Content via iframe */}
        <div className="flex-1 overflow-hidden">
          <iframe
            src={pdfUrl}
            className="w-full h-full border-0"
            title={title}
            onLoad={() => console.log('PDF chargé via iframe:', pdfUrl)}
            onError={(e) => console.error('Erreur chargement iframe PDF:', e, 'URL:', pdfUrl)}
          />
        </div>

        {/* Footer */}
        <div className="p-3 border-t border-gray-600 bg-gray-800 rounded-b-lg">
          <div className="flex justify-between items-center text-sm text-gray-300">
            <span className="flex items-center gap-2">
              <i className="fa-solid fa-info-circle text-gray-400"></i>
              Utilisez les contrôles du navigateur pour naviguer dans le document
            </span>
            <span className="font-medium text-white">Guide d'utilisation {getTenantName()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IframePDFViewer;
